var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasUser && !_vm.parseDesc)?_c('IndexList'):_c('div',[_c('h1',{staticStyle:{"margin-bottom":"40px"}},[_vm._v(" "+_vm._s(_vm.$t('index.header'))+" ")]),_vm._v(" "+_vm._s(_vm.parseDesc)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }